export const CALENDARS_ONLY = "calendars only";
export const NEWSLETTER_ONLY = "newsletter only";
export const CALENDARS_AND_NEWSLETTER = "calendars and newsletter";
